import { HttpClient, RequestParams } from "./base/BaseHttpClient";
import { FeatureFlagsConfiguration } from "./contracts/models";

export class FeatureFlagApi<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags FeatureFlag
   * @name Get
   * @request GET:/api/feature-flags
   * @response `200` `FeatureFlagsConfiguration` OK
   */
  get = (params: RequestParams = {}) =>
    this.http
      .request<FeatureFlagsConfiguration, any>({
        path: `/api/feature-flags`,
        method: "GET",
        credentials: "include",
        format: "json",
        ...params,
      })
      .then((m) => m.data);
}
